export default __webpack_public_path__ + "static/media/AggregateLogo.b4168ccb.png";